import React, { useEffect, useState } from "react";
import {
  Grid,
  Card,
  CardContent,
  Typography,
  Button,
  Box,
} from "@mui/material";
import { styled } from "@mui/material/styles";



// Styled component for custom product cards
const CustomCard = styled(Card)(({ theme, selected }) => ({
  backgroundColor: `${selected? "#00AEEF" : "transparent"}`,
  color: `${selected? "white" : "black"}`,
  borderRadius: theme.shape.borderRadius,
  fontWeight: "100",
  border: `2px solid ${selected ? "#00AEEF" : "transparent"}`,
  transition: "border-color 0.3s",
  cursor: "pointer",
  "&:hover": {
    borderColor: "#00AEEF",
  },
  width: "100%",
}));


const SelectProduct = ({ products, handleContinue, data, t }) => {
  const [selectedProductId, setSelectedProductId] = useState([]);
  
  useEffect(()=>{
    if(data){
      setSelectedProductId(data);
    }
  },[data])

  const handleCardClick = (id) => {
    setSelectedProductId((prevSelected) => {
      // Check if the id already exists in the selectedProductId array
      if (prevSelected.includes(id)) {
        // If it exists, remove it by filtering it out
        return prevSelected.filter((productId) => productId !== id);
      } else {
        // If it doesn't exist, add it to the array
        return [...prevSelected, id];
      }
    });
  };

  const checkForSelection = (id) => selectedProductId.includes(id);


  return (
    <Box sx={{ p: 4, width: '65vw' }}>
      <Typography variant="h4" sx={{ mb: 4 }}>
        {t('SelectProduct')}
      </Typography>
      {/* Product grid */}
      <Grid container spacing={2}>
        {products && products.map((product) => (
          <Grid
            item
            key={product.id}
          >
            <CustomCard
              selected={checkForSelection(product.id)}
              sx={{ borderRadius: "16px", width: '18vw' }}
              onClick={() => handleCardClick(product.id)}
            >
              <CardContent>
                <Typography variant="h6" component="div">
                  {product.name}
                </Typography>
              </CardContent>
            </CustomCard>
          </Grid>
        ))}
      </Grid>
      {
        products.length === 0 && (
          <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '60vh',  // Optional, centers content vertically if required
          }}
        >
          <Typography variant="h6" component="div" sx={{ textAlign: 'center', color: 'textDisabled.main' }}>
            {t('noproducts')}
          </Typography>
        </Box>
        
        )
      }
      <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 4 }}>
        <Button
          variant="contained"
          size="large"
          sx={{ backgroundColor: "#00AEEF", color: "white" }}
          onClick={()=>handleContinue(selectedProductId)}
          disabled={products.length<1 || selectedProductId.length<1}
        >
          {t('Continue')}
        </Button>
      </Box>
    </Box>
  );
};

export default SelectProduct;
